import React, { ReactNode } from 'react'

import { ErrorMessage, FieldHookConfig, useField } from 'formik'
import NumberFormat from 'react-number-format'

interface CustomProps {
  label?: string
  labelFlag?: ReactNode
  decimalScale?: number
  inputStyle?: string
  name?: string
  parentClassName?: string
  labelClassName?: string
  defaultLabel?: string
  noPlaceholder?: boolean
}

// @TODO - Remove `any` by defining what props we should pass to <NumberFormat />
type CustomNumberFormatProps = any

type NumberFieldProps = CustomProps & CustomNumberFormatProps & FieldHookConfig<string>

/**
 * @deprecated use Formik > Field and customize at the feature level
 * @see useForm() hook
 */
const NumberField = (props: NumberFieldProps) => {
  const {
    label,
    labelFlag,
    decimalScale = undefined,
    inputStyle = 'minimal',
    name = '',
    extraClassName = '',
    labelClassName = '',
    defaultLabel = '~',
    noPlaceholder = false,
    prefix,
    thousandSeparator,
    allowNegative,
    placeholder,
    parentClassName,
    ...otherProps
  } = props
  const [field, , helpers] = useField(props)

  const fieldClasses = inputStyle === 'minimal' ? 'minimal-input' : 'classic-input'

  const readOnlyClasses = 'bg-gray-300/70'
  const disabledClasses = 'disabled:text-gray-400'

  return (
    <div className={parentClassName}>
      {!!label && (
        <label className={`text-sm text-gray-400 block mb-2 flex ${labelClassName}`}>
          {label}
          {labelFlag}
        </label>
      )}

      <NumberFormat
        {...otherProps}
        decimalScale={decimalScale}
        placeholder={
          noPlaceholder
            ? ''
            : prefix === undefined
              ? '$0.00'
              : prefix === '%'
                ? '0%'
                : placeholder || defaultLabel
        }
        value={field.value === null ? '' : field.value}
        prefix={prefix == undefined ? '$' : prefix}
        thousandSeparator={thousandSeparator ?? true}
        allowNegative={allowNegative ?? false}
        className={`${fieldClasses} ${extraClassName} ${props.readOnly ? readOnlyClasses : ''} ${
          props.disabled ? disabledClasses : ''
        }`}
        onValueChange={(values) => {
          helpers.setValue(typeof values.floatValue === 'number' ? values.floatValue : null)
        }}
      />
      <ErrorMessage
        component='span'
        name={name}
        className='text-error'
      />
    </div>
  )
}

/** @deprecated Use the Formik Field and style it using the useForms hook  */
export default NumberField
